function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.76 17.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "copy_code_btn",
    "data-name": "copy code btn"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2561414_copy_icon",
    "data-name": " 2561414 copy icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_583",
    "data-name": "Rechteck 583",
    x: 6.76,
    y: 6.76,
    width: 10,
    height: 10,
    rx: 2,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1504",
    "data-name": "Pfad 1504",
    d: "M3.33,11.09H2.55A1.56,1.56,0,0,1,1,9.53v-7A1.54,1.54,0,0,1,2.55,1h7a1.55,1.55,0,0,1,1.56,1.55h0v.78",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.5472fb6f94e9c3f1afb1c207b12721eb.svg";
export { ForwardRef as ReactComponent };